import React, { forwardRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { ICellRendererParams } from "ag-grid-community";

interface CellProps extends ICellRendererParams {
  iconType: string;
  onClick?: (rowData: any) => void;
}

interface HeaderProps {
  iconType: string;
  onClick?: () => void;
}

type ButtonBoxCellEditorProps = CellProps | HeaderProps;

const ButtonBoxCellEditor = forwardRef<
  HTMLButtonElement,
  ButtonBoxCellEditorProps
>((props, ref) => {
  const { iconType, onClick } = props;
  const rowData = "data" in props ? props.data : undefined;

  // 아이콘 타입별 렌더링
  const renderIcon = () => {
    switch (iconType) {
      case "btn_delete":
        return (
          <CloseIcon
            sx={{
              fontSize: 20,
              fontWeight: "bold",
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <button
      style={{ margin: 0 }}
      ref={ref}
      onClick={() => {
        if (onClick) onClick(rowData);
      }}
    >
      {renderIcon()}
    </button>
  );
});

export default ButtonBoxCellEditor;
